import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { CONFIG } from '../../../../config'
import {
  parseToMysqlFormatWithTime00,
  parseToMysqlFormatWithTime23,
} from '../../../util/date.service'
import { openReportInNewTab } from '../../../util/report.service'
import axios from 'axios'

const { ENVIROMENT } = CONFIG
const DOC_BASE_URL = `${CONFIG[ENVIROMENT]['DOCS_END_POINT']}`

const MovimentacaoDevolucaoHttp = {
  baseURL: `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/patrimonio`,

  async saveMovimentacao(movimentacao) {
    try {
      const url = this.baseURL + '/movimentacao-devolucao'
      const response = await authHttp().post(url, movimentacao)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updateMovimentacao(movimentacao) {
    try {
      const url = this.baseURL + '/update/movimentacao-devolucao'
      const response = await authHttp().put(url, movimentacao)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getMovimentacoesDevolucao(dataInicial, dataFinal, selectedTp) {
    try {
      const pInicial = parseToMysqlFormatWithTime00(dataInicial)
      const pFinal = parseToMysqlFormatWithTime23(dataFinal)

      const url =
        this.baseURL +
        `/movimentacao-devolucao?pInicial=${pInicial}&pFinal=${pFinal}&tpId=${selectedTp}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  emitirComprovante(movimentacaoRecebimentoId) {
    const url =
      this.baseURL +
      `/movimentacao-devolucao/emitir-comprovante/${movimentacaoRecebimentoId}?t=${localStorage.getItem('t')}`
    openReportInNewTab(url)
  },

  async getMovimentacaoDevolucaoById(movimentacaoDevolucaoId) {
    try {
      const url = this.baseURL + `/movimentacao-devolucao/${movimentacaoDevolucaoId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updatePathComprovante(movimentacaoDevolucaoId, pathComprovante) {
    try {
      const url =
        this.baseURL +
        `/movimentacao-devolucao/update-path-comprovante/${movimentacaoDevolucaoId}`
      const response = await authHttp().put(url, { path_comprovante: pathComprovante })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async deleteComprovanteFile(filename) {
    try {
      const url = `${DOC_BASE_URL}/patrimonio-devolucao/${filename}`
      const response = await axios.delete(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  urlUploadComprovante(movimentacaoDevolucaoId) {
    return `${DOC_BASE_URL}/patrimonio-devolucao/${movimentacaoDevolucaoId}`
  },
}

export default MovimentacaoDevolucaoHttp
